import Avatar from '@shared/components/Avatar/Avatar';
import { useTranslation } from 'react-i18next';

import AvatarSetting from 'components/AvatarSetting/AvatarSetting';
import useRoomAvatar from 'modules/Workspaces/hooks/useRoomAvatar';
import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';

const WorkspaceLogoSetting = () => {
  const { t } = useTranslation();
  const { workspaceId, workspacesState } = useWorkspacesContext({ requireWorkspaceId: true });
  const { avatarUrl, changeAvatar, clearAvatar, loading } = useRoomAvatar({ roomId: workspaceId });

  const workspaceName = workspacesState.workspaces[workspaceId]?.name || t('workspaces.workspace');
  const fallbackAvatar = <Avatar size="lg" name={workspaceName} />;

  return (
    <AvatarSetting
      title={t('workspaces.workspace_logo')}
      avatarUrl={avatarUrl}
      onChange={changeAvatar}
      onClear={clearAvatar}
      isLoading={loading}
      fallbackAvatar={fallbackAvatar}
    />
  );
};

export default WorkspaceLogoSetting;
